module.exports = "/img/_/_/_/assets/images/creeper/book/epic//empty.jpg?05eefac45e660a6851e4977baeb19059";